import React from "react";
import "../styles/forms.css";
import PropTypes from "prop-types";
import {
  getDataFrm,
  DeleteDatosLaborales,
  getPerfil,
} from "../requests/req_perfil";
import { Col, FormGroup, UncontrolledTooltip, Button } from "reactstrap";
import { withStyles } from "@material-ui/styles";
import Chip from "@material-ui/core/Chip";
import { notifica, show_ldr } from "../requests/utils";
import Swal from "sweetalert2";
import {
  getPrestaciones,
  getBeneficios,
  getTiposContratacion,
  getTiposJornada,
} from "../requests/CatalogosGenerales";
import { postInsertarPreferencias } from "./../requests/PerfilCandidato";

const styles = (theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: "4px",
    },
  },
});

class FrmPreferencias extends React.Component {
  constructor(props) {
    super(props);
    let data = props?.datos?.length > 0 ? props?.datos[0] : {};
    if (
      data.Beneficios === "" &&
      data.Prestaciones === "" &&
      data.SueldoDeseado === "" &&
      data.TipoContratacion === "" &&
      data.TipoJornada === "" &&
      data.SueldoDeseado === ""
    ) {
      data = [];
    } else {
      data = props.datos;
    }
    let datos = this.props.datos?.length > 0 ? this.props.datos[0] : {};
    if (this.props.datos?.length > 0) {
      datos.disponibilidadCambioResidencia =
        this.props.datos[0].disponibilidadCambioResidencia === "True";
      datos.disponibilidadViaje =
        this.props.datos[0].disponibilidadViaje === "True";
    }

    this.state = {
      datos: datos,
      data: data,
      checkdisponibilidadViaje: false,
      checkdisponibilidadCambioResidencia: false,
      edit: false,
      chipData: this.props.preferencias != null ? this.props.preferencias : [],
      prestaciones: [],
      beneficios: [],
      tiposContratacion: [],
      tiposJornada: [],
    };
    this.editar = this.editar.bind(this);
    this.guardarInf = this.guardarInf.bind(this);
    this.generaCombo = this.generaCombo.bind(this);
    this.editCloseForm = this.editCloseForm.bind(this);
    this.asignarValores = this.asignarValores.bind(this);
    this.generaDivs = this.generaDivs.bind(this);
    this.agregareditar = this.agregareditar.bind(this);
    this.eliminarPreferencia = this.eliminarPreferencia.bind(this);
    this.eliminar = this.eliminar.bind(this);
    this.limpiarControles = this.limpiarControles.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.onChange = this.onChange.bind(this);
    this.createChips = this.createChips.bind(this);
    this.validaCampos = this.validaCampos.bind(this);
  }

  componentDidMount() {
    getPrestaciones().then((res) => {
      this.setState({ prestaciones: res });
    });
    getBeneficios().then((res) => {
      this.setState({ beneficios: res });
    });
    getTiposContratacion().then((res) => {
      this.setState({ tiposContratacion: res });
    });
    getTiposJornada().then((res) => {
      this.setState({ tiposJornada: res });
    });
    this.editar(null, true);
    if (this.state.datos != null) {
      if (this.state.datos.idPreferenciaCandidato !== 0) {
        if (localStorage.getItem("frmdl") != null) {
          this.editCloseForm(localStorage.getItem("frmdl"));
        }
      }
    }
  }

  componentWillUnmount() {
    var json = getDataFrm(".frmdl");
    var Val = JSON.parse(json);
    if (this.state.edit) {
      if (
        Val.SueldoDeseado !== "" ||
        (Val.Prestaciones !== "" && parseInt(Val.Prestaciones) !== 0) ||
        (Val.Beneficios !== "" && parseInt(Val.Beneficios) !== 0) ||
        (Val.TipoContratacion !== "" && parseInt(Val.TipoContratacion) !== 0) ||
        (Val.TipoJornada !== "" && parseInt(Val.TipoJornada) !== 0)
      )
        localStorage.setItem("frmdl", json);
      else localStorage.removeItem("frmdl");
    } else {
      localStorage.removeItem("frmdl");
    }
  }

  editCloseForm(data) {
    if (data != null) {
      var Items = JSON.parse(data);
      var idTipoJornada = document.getElementById("idTipoJornada");
      var idTipoContratacion = document.getElementById("idTipoContratacion");
      var idBeneficios = document.getElementById("idBeneficios");
      var idPrestaciones = document.getElementById("idPrestaciones");
      var SueldoDeseado = document.getElementById("SueldoDeseado");
      var cambioResidencia = document.getElementById(
        "disponibilidadCambioResidencia"
      );
      var dispViaje = document.getElementById("disponibilidadViaje");
      idTipoJornada.value = Items.TipoJornada != null ? Items.TipoJornada : "0";
      idTipoContratacion.value =
        Items.TipoContratacion != null ? Items.TipoContratacion : "0";
      idBeneficios.value = Items.Beneficios != null ? Items.Beneficios : "0";
      idPrestaciones.value =
        Items.Prestaciones != null ? Items.Prestaciones : "0";
      SueldoDeseado.value =
        Items.SueldoDeseado != null ? Items.SueldoDeseado : "0";
      cambioResidencia.checked =
        Items.DispCambio != null ? Items.DispCambio : false;
      dispViaje.checked = Items.DispViajar != null ? Items.DispViajar : false;

      var inps = document.querySelectorAll(".frmdl");
      var btnS = document.getElementById("img_sv_DL");
      var btnEdit = document.getElementById("btnEditPref"),
        formPref = document.getElementById("dv_FrmPref");
      formPref.classList.remove("Hide_All");
      btnEdit.classList.add("Hide_All");
      btnS.classList.remove("Hide_All");
      inps.forEach(function (i) {
        i.disabled = false;
      });
    }
  }
  componentWillMount() {}
  editar(e, atr) {
    this.setState({ edit: !atr });
    var inps = document.querySelectorAll(".frmdl"),
      btnS = document.getElementById("img_sv_DL"),
      formPref = document.getElementById("dv_FrmPref");
    if (e !== null) {
      let elm = document.getElementById("btnEditPref");
      elm.classList.add("Hide_All");
      btnS.classList.remove("Hide_All");
      formPref.classList.remove("Hide_All");
    } else {
      let elm = document.getElementById("btnEditPref");
      elm.classList.remove("Hide_All");
      btnS.classList.add("Hide_All");
      formPref.classList.add("Hide_All");
    }
    inps.forEach(function (i) {
      i.disabled = atr;
    });
    //  this.agregareditar(null,this.state.datos);
  }

  guardarInf(e, atr) {
    if (!this.validaCampos()) return;

    this.setState({ edit: false });
    var values = "";
    for (var i = 0; i < this.state.chipData.length; i++) {
      values += this.state.chipData[i].key;

      values += ",";
    }

    var json = getDataFrm(".frmdl");
    if (values != null && values !== "") {
      json =
        json.substr(0, json.length - 1) +
        ',"idsPrestaciones":"' +
        values +
        '"}';
    }
    let data = JSON.parse(json);
    var parsedData = {
      IdPreferenciaCandidato: 0,
      IdCandidato: parseInt(data.idCandidato),
      IdBeneficios: parseInt(data.Beneficios),
      DisponibilidadCambioResidencia: data.DispCambio === "true",
      DisponibilidadViaje: data.DispViajar === "true",
      Prestaciones: data.idsPrestaciones,
      SalarioMinimo: parseInt(data.SueldoDeseado),
      IdTipoContratacion: parseInt(data.TipoContratacion),
      IdTipoJornada: parseInt(data.TipoJornada),
    };

    show_ldr(true);
    postInsertarPreferencias(parsedData).then((res) => {
      show_ldr(false);
      getPerfil((p) => this.asignarValores(p));
    });

    var inps = document.querySelectorAll(".frmdl"),
      btnS = document.getElementById("img_sv_DL"),
      btng = document.getElementById("btnEditPref"),
      formPref = document.getElementById("dv_FrmPref");

    if (e !== null) {
      var elm = e.target;
      elm.classList.remove("Hide_All");
      btnS.classList.add("Hide_All");
      btng.classList.remove("Hide_All");
      formPref.classList.add("Hide_All");
    }
    inps.forEach(function (i) {
      i.disabled = atr;
    });
  }

  asignarValores(datos) {
    var lblSueldo = document.getElementById("lblSueldo");

    if (lblSueldo) {
      var sueldo = document.getElementById("SueldoDeseado");
      lblSueldo.innerText = "Expectativa salarial: $" + sueldo.value;
    }
    var btnrefresh = document.getElementById("btnrefresh");
    if (btnrefresh) btnrefresh.click();
    this.setState({ edit: false });
    var disponibilidadCambioResidencia = document.getElementById(
        "disponibilidadCambioResidencia"
      ),
      disponibilidadViaje = document.getElementById("disponibilidadViaje"),
      idTipoJornada = document.getElementById("idTipoJornada"),
      idTipoContratacion = document.getElementById("idTipoContratacion"),
      idBeneficios = document.getElementById("idBeneficios"),
      idPrestaciones = document.getElementById("idPrestaciones"),
      SueldoDeseado = document.getElementById("SueldoDeseado"),
      //idPreferencias = document.getElementById("idPreferencias"),
      lblEditarForm = document.getElementById("lblEditarForm");
    let data = datos.tabla7;
    if (
      data.Beneficios === "" &&
      data.Prestaciones === "" &&
      data.SueldoDeseado === "" &&
      data.TipoContratacion === "" &&
      data.TipoJornada === "" &&
      data.SueldoDeseado === ""
    ) {
      data = [];
    }
    this.setState({
      data: data,
    });

    lblEditarForm.innerText = "Editar Información";
  }

  generaCombo(datos) {
    if (datos !== null) {
      return datos.map((i, index) => {
        return (
          <option value={i.IdValor} key={index}>
            {i.Descripcion}
          </option>
        );
      });
    }
  }
  handleChange = (e) => {
    let { datos } = this.state;
    var data = datos;
    data[e.target.name] = e.target.value;
    this.setState({
      datos: data,
    });
  };

  handleChecked = (e) => {
    let { datos } = this.state;
    var data = datos;
    data[e.target.name] = e.target.checked;
    this.setState({
      datos: data,
    });
  };
  agregareditar(ev, e) {
    var disponibilidadCambioResidencia = document.getElementById(
        "disponibilidadCambioResidencia"
      ),
      disponibilidadViaje = document.getElementById("disponibilidadViaje"),
      idTipoJornada = document.getElementById("idTipoJornada"),
      idTipoContratacion = document.getElementById("idTipoContratacion"),
      idBeneficios = document.getElementById("idBeneficios"),
      idPrestaciones = document.getElementById("idPrestaciones"),
      SueldoDeseado = document.getElementById("SueldoDeseado"),
      idPreferencias = document.getElementById("idPreferencias");
    disponibilidadCambioResidencia.checked = e.disponibilidadCambioResidencia;
    disponibilidadViaje.checked = e.disponibilidadViaje;
    idTipoJornada.value = e.idTipoJornada;
    idTipoContratacion.value = e.idTipoContratacion;
    idBeneficios.value = e.idBeneficios;
    idPrestaciones.value = e.idPrestaciones;
    SueldoDeseado.value = e.SueldoDeseado;
    idPreferencias.value = e.idPreferenciaCandidato;
    var inps = document.querySelectorAll(".frmdl");
    var btnS = document.getElementById("img_sv_DL"),
      formPref = document.getElementById("dv_FrmPref");
    if (e !== null) {
      var elm = document.getElementById("btnEditPref");
      elm.classList.add("Hide_All");
      btnS.classList.remove("Hide_All");
      formPref.classList.remove("Hide_All");
    }
    inps.forEach(function (i) {
      i.disabled = false;
    });
    this.setState({ edit: true });
  }

  eliminarPreferencia(ev, e) {
    let resp = e;
    Swal.fire({
      title: "¿Estas seguro que deseas eliminar?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
    }).then((result) => {
      if (result.value) {
        var Item = {
          idPreferencias: resp.idPreferenciaCandidato,
        };
        DeleteDatosLaborales(Item, (x) =>
          this.eliminar(x, Item.idPreferencias)
        );
        this.setState({ chipData: [] });
        this.limpiarControles();
      }
    });
  }

  eliminar(datos, v) {
    if (datos != null) {
      if (datos?.ok) {
        var dv2 = document.getElementById("dvPref" + parseInt(v, 10));
        var Item = {
          Beneficios: "",
          Prestaciones: "",
          SueldoDeseado: "",
          TipoContratacion: "",
          TipoJornada: "",
          disponibilidadCambioResidencia: false,
          disponibilidadViaje: false,
          idBeneficios: 0,
          idPreferenciaCandidato: 0,
          idPrestaciones: 0,
          idTipoContratacion: 0,
          idTipoJornada: 0,
        };
        if (dv2 != null) dv2.classList.add("Hide_All");
        for (var i = 0; i < this.state.data.length; i++) {
          if (this.state.data[i].idPreferenciaCandidato === parseInt(v, 10)) {
            this.state.data.splice(i, 1);
          }
        }
        var SueldoDeseado = document.getElementById("SueldoDeseado");
        SueldoDeseado.value = "";
        this.setState({ datos: Item });
        var btnrefresh = document.getElementById("btnrefresh");
        if (btnrefresh) btnrefresh.click();
      }
    }
  }

  limpiarControles() {
    var disponibilidadCambioResidencia = document.getElementById(
        "disponibilidadCambioResidencia"
      ),
      disponibilidadViaje = document.getElementById("disponibilidadViaje"),
      idTipoJornada = document.getElementById("idTipoJornada"),
      idTipoContratacion = document.getElementById("idTipoContratacion"),
      idBeneficios = document.getElementById("idBeneficios"),
      idPrestaciones = document.getElementById("idPrestaciones"),
      SueldoDeseado = document.getElementById("SueldoDeseado"),
      idPreferencias = document.getElementById("idPreferencias"),
      lblEditarForm = document.getElementById("lblEditarForm");
    disponibilidadCambioResidencia.checked = false;
    disponibilidadViaje.checked = false;
    idTipoJornada.value = 0;
    idTipoContratacion.value = 0;
    idBeneficios.value = 0;
    idPrestaciones.value = 0;
    SueldoDeseado.value = 0;
    idPreferencias.value = 0;
    lblEditarForm.innerText = "Agregar Información";
  }

  generaDivs(datos) {
    const { edit } = this.state;
    if(!datos) return null;
    return datos.map((e, index) => {
      return (
        <div
          className="dv_Formacion"
          id={"dvPref" + e.idPreferenciaCandidato}
          key={index}
        >
          <div className="dv_Full_frmcn">
            <div className="dv_Full_frmcn_Lft">
              <label>
                Tipo de Jornada:{" "}
                {e.tipoJornada !== "" ? e.tipoJornada : "Sin Datos"}
              </label>
            </div>
            <div className="dv_Full_frmcn_Rgt">
              <label>
                Sueldo deseado: $
                {e.sueldoDeseado != null ? `${e.sueldoDeseado}.00 MXN` : 0}
              </label>
              <img
                src={window.origin + "/images/icon_delete_1.png"}
                alt="Eliminar"
                id={"imgform_delete" + e.idPreferenciaCandidato}
                onClick={(x) => this.eliminarPreferencia(x, e)}
                className={edit ? "d-none" : ""}
              />
              <UncontrolledTooltip
                placement="top"
                target={"imgform_delete" + e.idPreferenciaCandidato}
              >
                Eliminar
              </UncontrolledTooltip>
            </div>
          </div>
          <label>{"Tipo Contratación Deseada: " + e.tipoContratacion}</label>
          <br />
        </div>
      );
    });
  }

  onChange(e) {
    const { options } = e.target;

    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected && options[i].value !== "0") {
        var item = { key: options[i].value, label: options[i].text };
        var arr = this.state.chipData;
        arr = arr.filter((x) => x.key !== options[i].value);
        arr.push(item);
        this.setState({ chipData: arr });
      }
    }
  }

  createChips() {
    return this.state.chipData.map((data) => {
      if (data.key !== 0)
        return (
          <Chip
            key={data.key}
            label={data.label}
            color={"primary"}
            size={"medium"}
            onDelete={(e) => this.handleDelete(data)}
          />
        );
      return null;
    });
  }
  handleDelete(data) {
    if (data != null) {
      var arr = this.state.chipData;
      arr = arr.filter((x) => x.key !== data.key);
      this.setState({ chipData: arr });
    }
  }
  validaCampos() {
    const {
      chipData,
      datos: { SueldoDeseado, idBeneficios, idTipoContratacion, idTipoJornada },
    } = this.state;
    var i = 0,
      error = [];

    if (SueldoDeseado === "" || Number(SueldoDeseado) === 0) {
      error.push("Sueldo Deseado");
      i++;
    }

    if (chipData.length === 0 || chipData == null) {
      error.push("Prestaciones");
      i++;
    }

    if (Number(idBeneficios) === 0 || idBeneficios == null) {
      error.push("Beneficios Deseados");
      i++;
    }

    if (Number(idTipoContratacion) === 0 || idTipoContratacion == null) {
      error.push("Tipo de Contratación");
      i++;
    }

    if (Number(idTipoJornada) === 0 || idTipoJornada == null) {
      error.push("Tipo de Jornada");
      i++;
    }

    if (i > 0) {
      notifica(
        "warning",
        `Los campos ${error.join(", ")} son obligatorios`,
        "Alerta!"
      );
      return false;
    } else return true;
  }
  render() {
    const { classes } = this.props;
    return (
      <div className="APL_Frm_dv">
        <FormGroup className="dv_Form_New_Edit Hide_All" id="dv_FrmPref" row>
          <Col sm={0} md={0} lg={1} />
          <Col sm={6} md={6} lg={5}>
            <input
              type="hidden"
              className="frm frmdl Hide_All"
              id="idPreferencias"
              datsvfrm="idPreferencias"
            />{" "}
            <label className="lbl_md">
              Sueldo deseado:<span style={{ color: "red" }}>*</span>
            </label>{" "}
          </Col>
          <Col
            sm={6}
            md={6}
            lg={5}
            className="row"
            style={{ marginLeft: "4px" }}
          >
            <div className="col-md-1">$</div>
            <div className="col-md-8" style={{ paddingRight: "0%" }}>
              <input
                type="number"
                min="0.00"
                datsvfrm="SueldoDeseado"
                className="frm frmdl"
                name="SueldoDeseado"
                id="SueldoDeseado"
                step="100"
                value={
                  this.state.datos != null ? this.state.datos.SueldoDeseado : ""
                }
                onChange={this.handleChange}
              />
            </div>
            <div className="col-md-1">MXN</div>
          </Col>
          <Col sm={0} md={0} lg={1} />
          <Col sm={0} md={0} lg={1} />
          <Col sm={6} md={6} lg={5}>
            {" "}
            <label className="lbl_md">
              Prestaciones:<span style={{ color: "red" }}>*</span>
            </label>{" "}
          </Col>
          <Col sm={6} md={6} lg={5}>
            <select
              className="frm frmdl"
              datsvfrm="Prestaciones"
              name="idPrestaciones"
              id="idPrestaciones"
              defaultChecked={
                this.state.datos != null ? this.state.datos.idPrestaciones : 0
              }
              multiple
              onChange={(e) => this.onChange(e)}
            >
              <option value="0">Selecciona...</option>
              {this.state.prestaciones.map((item, index) => {
                return (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                );
              })}
            </select>
          </Col>
          <Col sm={0} md={0} lg={1} />
          <Col sm={0} md={0} lg={1} />
          <Col sm={12} md={12} lg={10}>
            <div className={classes.root}>{this.createChips()}</div>
          </Col>
          <Col sm={0} md={0} lg={1} />
          <Col sm={0} md={0} lg={1} />
          <Col sm={6} md={6} lg={5}>
            {" "}
            <label className="lbl_md">
              Beneficios:<span style={{ color: "red" }}>*</span>
            </label>{" "}
          </Col>
          <Col sm={6} md={6} lg={5}>
            <select
              className="frm frmdl"
              datsvfrm="Beneficios"
              name="idBeneficios"
              id="idBeneficios"
              value={
                this.state.datos != null ? this.state.datos.idBeneficios : 0
              }
              onChange={this.handleChange}
            >
              <option value="0">Selecciona...</option>
              {this.state.beneficios.map((item, index) => {
                return (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                );
              })}
            </select>
          </Col>
          <Col sm={0} md={0} lg={1} />
          <Col sm={0} md={0} lg={1} />
          <Col sm={6} md={6} lg={5}>
            {" "}
            <label className="lbl_md">
              Tipo Contratación Deseada:<span style={{ color: "red" }}>*</span>
            </label>{" "}
          </Col>
          <Col sm={6} md={6} lg={5}>
            <select
              className="frm frmdl"
              datsvfrm="TipoContratacion"
              name="idTipoContratacion"
              id="idTipoContratacion"
              value={
                this.state.datos != null
                  ? this.state.datos.idTipoContratacion
                  : 0
              }
              onChange={this.handleChange}
            >
              <option value="0">Selecciona...</option>
              {this.state.tiposContratacion.map((item, index) => {
                return (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                );
              })}
            </select>
          </Col>
          <Col sm={0} md={0} lg={1} />
          <Col sm={0} md={0} lg={1} />
          <Col sm={6} md={6} lg={5}>
            {" "}
            <label className="lbl_md">
              Tipo de Jornada:<span style={{ color: "red" }}>*</span>
            </label>{" "}
          </Col>
          <Col sm={6} md={6} lg={5}>
            <select
              className="frm frmdl"
              datsvfrm="TipoJornada"
              name="idTipoJornada"
              id="idTipoJornada"
              value={
                this.state.datos != null ? this.state.datos.idTipoJornada : 0
              }
              onChange={this.handleChange}
            >
              <option value="0">Selecciona...</option>
              {this.state.tiposJornada.map((item, index) => {
                return (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                );
              })}
            </select>
          </Col>
          <Col sm={0} md={0} lg={1} />
          <Col sm={0} md={0} lg={1} />
          <Col sm={6} md={6} lg={5}>
            {" "}
            <label className="lbl_md">Disponibilidad para Viajar</label>{" "}
          </Col>
          <Col sm={6} md={6} lg={6}>
            <label htmlFor="disponibilidadViaje" className="switch">
              <input
                type="checkbox"
                className="fctlg frmdl"
                id="disponibilidadViaje"
                name="disponibilidadViaje"
                datsvfrm="DispViajar"
                checked={
                  this.state.datos
                    ? this.state.datos.disponibilidadViaje
                    : false
                }
                onChange={(e) => {
                  this.handleChecked(e);
                }}
              />
              <span className="slider round" />
            </label>
          </Col>
          <Col sm={0} md={0} lg={1} />
          <Col sm={6} md={6} lg={5}>
            {" "}
            <label className="lbl_md">
              Disponibilidad para Cambio Residencia
            </label>{" "}
          </Col>
          <Col sm={6} md={6} lg={6}>
            <label htmlFor="disponibilidadCambioResidencia" className="switch">
              <input
                type="checkbox"
                className="fctlg frmdl"
                id="disponibilidadCambioResidencia"
                name="disponibilidadCambioResidencia"
                datsvfrm="DispCambio"
                checked={
                  this.state.datos
                    ? this.state.datos.disponibilidadCambioResidencia
                    : false
                }
                onChange={(e) => {
                  this.handleChecked(e);
                }}
              />
              <span className="slider round" />
            </label>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={9} md={9} lg={9}></Col>
          <Col sm={3} md={3} lg={3}>
            <Button
              outline
              color="success"
              className="btn_exp_add"
              alt="Editar"
              id="btnEditPref"
              onClick={(e) => this.editar(e, false)}
            >
              <img
                src={window.origin + "/images/icon_add_2.png"}
                className="img_edit"
                alt="Agregar"
              />
              <label style={{ wordWrap: "normal" }} id="lblEditarForm">
                {this.state.datos != null
                  ? this.state.datos.idPreferenciaCandidato !== 0
                    ? "Editar Información"
                    : "Agregar Información"
                  : "Agregar Información"}{" "}
              </label>
            </Button>
            <Button
              outline
              color="info"
              className="btn_exp_add Hide_All"
              alt="Guardar"
              id="img_sv_DL"
              onClick={(e) => this.guardarInf(e, true)}
            >
              <img
                src={window.origin + "/images/icon_save_2.png"}
                className="img_edit "
                alt=""
              />
              Guardar Cambios
            </Button>

            <UncontrolledTooltip placement="right" target="img_sv_DL">
              Guardar Cambios
            </UncontrolledTooltip>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={12} md={12} lg={12} id="dv_frmPref">
            {this.generaDivs(this.state.data)}
          </Col>
        </FormGroup>
      </div>
    );
  }
}

FrmPreferencias.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FrmPreferencias);
